import script from './FlagIcon.vue_rollup-plugin-vue=script.js';
import normalizeComponent from '../../node_modules/vue-runtime-helpers/dist/normalize-component.mjs.js';
import createInjector from '../../node_modules/vue-runtime-helpers/dist/inject-style/browser.mjs.js';

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function (_h,_vm) {var _c=_vm._c;return _c('CustomImage',{class:[_vm.data.staticClass, 'flag', { 'flag--lg': _vm.props.isLarge }],attrs:{"src":("/static/img/flags/" + (encodeURI(_vm.props.flag)))}})};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-c282ba28_0", { source: ".flag[data-v-c282ba28]{width:14px;height:14px;display:inline-block;margin-right:4px;margin-bottom:-2px}.flag--lg[data-v-c282ba28]{width:28px;height:28px;transform:scale(.75);margin-bottom:2px;margin-right:8px}.flag[data-v-c282ba28] img{width:inherit;height:inherit;border-radius:50%;box-shadow:inset 0 0 0 1px rgba(0,0,0,.16)}", map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__ = "data-v-c282ba28";
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = true;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    createInjector,
    undefined,
    undefined
  );

export default __vue_component__;
